const infoIcons = {
  department: {
    title: "Meine Abteilungen",
    body: "Abteilungen sind ein grundlegendes Element von XLplanner. Alle wichtigen Aktionen in der Anwendung führst du durch, indem du die Abteilung zuweist, auf die sich die geplante Aktion bezieht.",
    button: "Abteilung hinzufügen",
    missing: "Keine Abteilungen",
  },
  "outside-department": {
    title: "Externe Lagerhäuser",
    body: "Externe Lagerhäuser können als Entladeorte in Aufträgen verwendet werden. Du kannst ihnen keine Mitarbeiter zuweisen oder Kalender ausfüllen.",
    button: "Externes Lager hinzufügen",
    missing: "Keine externen Lagerhäuser",
  },
  warehouse: {
    title: "Meine Lagerhäuser",
    body: "Lagerhäuser sind ein grundlegendes Element von XLplanner. Alle wichtigen Aktionen in der Anwendung führst du durch, indem du das Lager zuweist, auf das sich die geplante Aktion bezieht.",
    button: "Lager hinzufügen",
    missing: "Keine Lagerhäuser",
  },
  workers: {
    title: "Mitarbeiter",
    body: "Lade Mitarbeiter zur Nutzung der Anwendung ein. Du kannst neue Benutzer hinzufügen, indem du eine der drei Rollen auswählst: Administrator, Manager oder Mitarbeiter. Jede Rolle hat unterschiedliche Berechtigungen. Nach dem Versenden der Einladung erhalten sie eine E-Mail mit den Anmeldedaten (wenn sie noch kein Konto haben) oder werden deinem Unternehmen hinzugefügt (wenn sie bereits ein XLplanner-Konto besitzen).",
    button: "Mitarbeiter hinzufügen",
    for: "Mitarbeiter anzeigen für",
    missing: "Keine Mitarbeiter",
  },
  drivers: {
    title: "Fahrer",
    body: "Fahrer sind notwendig, um Angebote für Aufträge abzugeben. Im Gegensatz zu Mitarbeitern haben sie kein Konto in der Anwendung.",
    button: "Fahrer hinzufügen",
    for: "Fahrer anzeigen für",
    missing: "Keine Fahrer",
  },
  documents: {
    title: "Dokumente",
    body: "Füge Dokumente hinzu, damit andere Benutzer dein Unternehmen kennenlernen können. Neben den Basisdokumenten kannst du beliebige Dateien hochladen und festlegen, ob sie öffentlich oder nur für dein Unternehmen sichtbar sein sollen.",
    button: "Dokument hinzufügen",
    missing: "Keine Dokumente",
  },
  cars: {
    title: "Meine Fahrzeuge",
    body: "Füge Fahrzeuge hinzu, um an Aufträgen teilzunehmen. Weise dem Fahrzeug den entsprechenden Lizenztyp zu. Lege das Ablaufdatum für Inspektionen und Versicherungen fest, und wir senden dir Erinnerungen an bevorstehende Fristen.",
    button: "Fahrzeug hinzufügen",
  },
  timeWindows: {
    title: "Zeitfenster",
    body: "Zeitfenster werden verwendet, um während der Terminplanung Buchungen vorzunehmen.",
    button: "Zeitfenster kaufen",
  },
  abonament: {
    title: "Abonnement",
    body: "Das Abonnement ermöglicht die Teilnahme an Aufträgen.",
    button: "Abonnement kaufen",
  },
  warehouseList: {
    title: "Lagerliste",
    body: "Hier findest du eine Liste von Lagern. Du findest hier Unternehmen, mit denen du eine Autorisierung durchführen kannst. Vor dem Senden einer Autorisierungsanfrage kannst du immer die wichtigsten Informationen und Dokumente des Unternehmens im Profil überprüfen.",
  },
  authorizations: {
    title: "Autorisierungen",
    body: "Hier findest du eine Liste aller Autorisierungsanfragen, die du an andere Unternehmen gesendet hast. Du kannst deine Anfragen auch zurückziehen.",
  },
  monitaryNote: {
    title: "Avisierungen",
    body: "In diesem Abschnitt siehst du alle gebuchten Avisierungen, deren Status und alle Details. Du hast hier auch Zugriff auf den Chat mit dem Lager, bei dem du die Avisierung vorgenommen hast, sowie die Möglichkeit, das Transportdokument herunterzuladen. Avisierungen können nur bei autorisierten Lagern gebucht werden.",
    button: "Avisierung hinzufügen",
  },
  postedAuction: {
    title: "Auftragsbörse",
    body: "Hier findest du Aufträge. Nach dem Kauf eines Abonnements kannst du Angebote abgeben, um Aufträge zu erhalten.",
  },
  currentAutcions: {
    title: "Laufende Aufträge",
    body: "Hier findest du die Aufträge, an denen du derzeit teilnimmst.",
  },
  assignedAuctions: {
    title: "Zugewiesene Aufträge",
    body: "Dies sind Aufträge, die dir nach Annahme deines Angebots zugewiesen wurden.",
  },
  assignedTransports: {
    title: "Zugewiesene Transporte",
    body: "Dies sind Aufträge, die direkt vom Spediteur ohne Angebotsabgabe erhalten wurden.",
    missing: "Keine Transporte.",
  },
  canceledTransports: {
    title: "Stornierte / nicht erhaltene Transporte",
    body: "Dies sind Aufträge, die storniert oder nicht erhalten wurden.",
  },
  declinedTransports: {
    title: "Nicht erhaltene Transporte",
    body: "Dies sind Aufträge, die deine Abteilung nicht erhalten hat.",
  },
  additionalPayment: {
    title: "Zusätzliche Zahlungen für Aufträge",
    body: "Dies ist eine Liste aller zusätzlichen Zahlungen, die den zugewiesenen Transporten hinzugefügt wurden.",
  },
  leasing: {
    title: "Leasing",
    body: "Reiche Leasinganträge ein, die wir prüfen werden. Du erhältst eine Benachrichtigung über unsere Entscheidung.",
    button: "Antrag einreichen",
    missing: "Keine Anträge",
  },
  factoring: {
    title: "Factoring",
    body: "Dies ist eine Liste aller Aufträge mit genehmigtem Factoring.",
    missing: "Keine Aufträge mit Factoring",
  },
  myWarehouses: {
    title: "Meine Lagerhäuser",
    body: "Lagerhäuser sind ein grundlegendes Element von XLplanner. Alle wichtigen Aktionen in der Anwendung führst du durch, indem du das Lager zuweist, auf das sich die geplante Aktion bezieht.",
    button: "Lager hinzufügen",
  },
  driversGroups: {
    title: "Pilotengruppen / Erstellte Gruppen",
    body: "Du kannst Pilotengruppen beim Erstellen von Aufträgen verwenden, wenn du nicht möchtest, dass sie öffentlich sichtbar sind. Wenn du einen Auftrag hinzufügst, wähle die bevorzugte Gruppe aus, die die Empfänger sein werden. Nur Piloten, die zu dieser Gruppe gehören, können den Auftrag sehen und Angebote abgeben. Du kannst nur autorisierte Piloten zu Gruppen hinzufügen.",
    button: "Gruppe erstellen",
    for: "Gruppen anzeigen für",
    missing: "Keine Gruppen für die ausgewählte Abteilung",
  },
  createCalendar: {
    title: "Kalender erstellen",
    body: "Fülle den Kalender für einen bestimmten Monat aus, damit Spediteure Zeitfenster in deinem Lager buchen können. Nach der Erstellung des Kalenders kannst du jeden Tag bearbeiten, Zeitfenster hinzufügen, ändern oder löschen.",
  },
  monitaryArchiveDriver: {
    for: "Abteilung auswählen",
    missing: "Keine archivierten Avisierungen für die ausgewählte Abteilung",
  },
  monitaryArchiveWarehouse: {
    for: "Lager auswählen",
    missing: "Keine archivierten Avisierungen für das ausgewählte Lager",
  },
  auctionsArchive: {
    missing: "Keine archivierten Aufträge",
  },
  auctionsForProducer: {
    missing: "Keine Aufträge",
  },
  authorizationsProducer: {
    title: "Autorisierungen",
    body: "Hier findest du eine Liste aller Autorisierungsanfragen. Du kannst sie annehmen oder ablehnen.",
  },
  monitaryNotesProducer: {
    title: "Avisierungen",
    body: "In diesem Abschnitt siehst du alle gebuchten Avisierungen, deren Status und alle Details. Du hast hier auch Zugriff auf den Chat mit dem Spediteur, der eine Avisierung in deinem Lager gebucht hat, sowie die Möglichkeit, das Transportdokument herunterzuladen. Hier kannst du auch bestätigen, ob der Fahrer zur vereinbarten Zeit angekommen ist.",
  },
  myAuctions: {
    title: "Meine Aufträge",
    body: "Dies sind alle von dir erstellten Aufträge. Du kannst Aufträge hinzufügen, bearbeiten und stornieren. Hier wählst du auch den Piloten aus, dem du den Auftrag zuweist.",
    button: "Auftrag hinzufügen",
  },
  cancelledAuctions: {
    title: "Stornierte Aufträge",
    body: "Dies ist eine Liste aller veröffentlichten Aufträge, die storniert wurden.",
  },
  participants: {
    title: "Teilnehmerliste",
    body: "Dies ist eine Liste aller Piloten, die an den von dir erstellten Aufträgen teilnehmen.",
    for: "Teilnehmer anzeigen für",
    missing: "Keine Teilnehmer",
  },
  wallet: {
    button: "Zeitfenster aufladen",
    buttonSub: "Abonnement kaufen",
  },
  invoiceList: {
    missing: "Keine ausgestellten Rechnungen.",
  },
  monthlyInvoices: {
    title: "Monatliche Rechnungen",
    body: "Hier findest du eine Übersicht aller Zahlungen für einen bestimmten Monat. Die Übersicht wird zu Beginn des Folgemonats erstellt.",
  },
};
export default infoIcons;
